import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services/api';
import { Tag } from 'src/models';

export const useCreateTag = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['createTag'],
    mutationFn: (
      tag: Omit<
        Tag,
        | 'id'
        | 'created_at'
        | 'created_by'
        | 'last_modified'
        | 'last_modified_by'
      >
    ) => api.post('/v3/tag', tag),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tagList'] });
    },
  });
};
